import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToDraftPolicy: {
        id: 'renewal.eu.config.Unable to save draft renewal',
        defaultMessage: 'Unable to save draft renewal'
    },
    anErrorOccurred: {
        id: 'renewal.eu.config.An error occurred while attempting to start the renewal.',
        defaultMessage: 'Something went wrong during this process. Pleuse try again.'
    },
    renewals: {
        id: 'renewal.eu.directives.templates.eu-whats-next.Renewals',
        defaultMessage: 'Renewals'
    },
    insuredDetails: {
        id: 'renewal.eu.directives.templates.eu-policy-renewals.Insured',
        defaultMessage: 'Insured'
    },
    reviewChangesLabel: {
        id: 'renewal.eu.directives.templates.eu-edit.reviewChangesLabel',
        defaultMessage: 'Review Changes'
    },
    vehicles: {
        id: 'renewal.eu.directives.templates.eu-edit-vehicle.Vehicles',
        defaultMessage: 'Vehicles'
    },
    drivers: {
        id: 'renewal.eu.directives.templates.eu-edit-driver.Drivers',
        defaultMessage: 'Drivers'
    },
    underwritingPage: {
        id: 'renewal.eu.directives.templates.eu-policy-renewals.Underwriting',
        defaultMessage: 'Underwriting'
    },
    anErrorOccurredTitle: {
        id: 'gw-portals-policytransaction-renewal-eu.wizard.error.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'gw-portals-policytransaction-renewal-eu.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'gw-portals-policytransaction-renewal-eu.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    tpiPageTitle: {
        id: 'renewal.eu.wizard.step.Third-Party Interest',
        defaultMessage: 'Third-Party Interest'
    },
    riskAnalysisPage: {
        id: 'renewal.eu.directives.templates.eu-edit-riskAnalysis.Risk Analysis',
        defaultMessage: 'Risk Analysis'
    },
    recalculateButtonLabel: {
        id: 'renewal.eu.directives.templates.eu-edit.recalculateButtonLabel',
        defaultMessage: 'Recalculate'
    },
    exitTransactionMessage: {
        id: 'renewal.eu.directives.templates.eu-edit.Information entered on prior pages will be saved as a draft. Any changes on this page will be lost. Changes will be discarded if not applied before the renewal is automatically bound.',
        defaultMessage: 'Information entered on prior pages will be saved as a draft. Any changes on this page will be lost. Changes will be discarded if not applied before the renewal is automatically bound.'
    }
});
